module.exports = __webpack_public_path__ + "img/main_05_product_img_02.ef3ff80c.png";